import { NgModule } from '@angular/core';
import { ROUTES } from '@angular/router';

import { AwardModalComponent } from 'app/projects/award-modal/award-modal.component';
import { CreateMilestoneModalComponent } from 'app/projects/create-milestone-modal/create-milestone-modal.component';
import { CreateMilestoneUpgradeModalComponent } from 'app/projects/create-milestone-upgrade-modal/create-milestone-upgrade-modal.component';
import { HiremeModalComponent } from 'app/projects/hireme-modal/hireme-modal.component';
import { RequestMilestoneModalComponent } from 'app/projects/request-milestone-modal/request-milestone-modal.component';

// Add here your modals configurations
const appModals = [
  {
    component: HiremeModalComponent,
    loadChildren:
      'app/projects/hireme-modal/hireme-modal.module#HiremeModalModule',
    compat: true,
    path: 'hack_path_not_used',
  },
  {
    component: RequestMilestoneModalComponent,
    loadChildren:
      'app/projects/request-milestone-modal/request-milestone-modal.module#RequestMilestoneModalModule',
    compat: true,
    path: 'hack_path_not_used',
  },
  {
    component: CreateMilestoneModalComponent,
    loadChildren:
      'app/projects/create-milestone-modal/create-milestone-modal.module#CreateMilestoneModalModule',
    compat: true,
    path: 'hack_path_not_used',
  },
  {
    component: CreateMilestoneUpgradeModalComponent,
    loadChildren:
      'app/projects/create-milestone-upgrade-modal/create-milestone-upgrade-modal.module#CreateMilestoneUpgradeModalModule',
    compat: true,
    path: 'hack_path_not_used',
  },
  {
    component: AwardModalComponent,
    loadChildren:
      'app/projects/award-modal/award-modal.module#AwardModalModule',
    path: 'hack_path_not_used',
  },
];

@NgModule({
  providers: [
    // Modals have nothing to do with routes, but this is a hack to make the
    // CLI code splitting and ngc lazy module analysis and compilation work,
    // pending proper fix in https://github.com/angular/angular-cli/issues/4541
    { provide: ROUTES, useValue: appModals, multi: true },
  ],
})
export class AppModalsModule {}



// WEBPACK FOOTER //
// ./src/app/app-modals.module.ts